import { FC } from 'react'
import { useIntl } from 'react-intl'
import { videoEmbedStyle } from './VideoEmbed.style'

/**
 * VideoEmbedProps contains properties for the component.
 */
export interface VideoEmbedProps {
  url: string
}

/**
 * VideoEmbed embeds a video
 * @param props Properties for component.
 * @returns JSX component.
 */
export const VideoEmbed: FC<VideoEmbedProps> = (props: VideoEmbedProps) => {
  const classes = videoEmbedStyle()
  const intl = useIntl()

  return (
    <div className={classes.videoResponsive}>
      <iframe
        className={classes.iframe}
        src={props.url}
        frameBorder='0'
        allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen
        title={intl.formatMessage({ id: 'embeddedvideo.title' })}
      />
    </div>
  )
}

export default VideoEmbed
